/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EvaluationScopeCategory } from './EvaluationScopeCategory';
import {
    EvaluationScopeCategoryFromJSON,
    EvaluationScopeCategoryFromJSONTyped,
    EvaluationScopeCategoryToJSON,
} from './EvaluationScopeCategory';
import type { ISystemSetupCombinationValue } from './ISystemSetupCombinationValue';
import {
    ISystemSetupCombinationValueFromJSON,
    ISystemSetupCombinationValueFromJSONTyped,
    ISystemSetupCombinationValueToJSON,
} from './ISystemSetupCombinationValue';
import type { ParameterCombinationDtoReferenceMeasurementInfo } from './ParameterCombinationDtoReferenceMeasurementInfo';
import {
    ParameterCombinationDtoReferenceMeasurementInfoFromJSON,
    ParameterCombinationDtoReferenceMeasurementInfoFromJSONTyped,
    ParameterCombinationDtoReferenceMeasurementInfoToJSON,
} from './ParameterCombinationDtoReferenceMeasurementInfo';

/**
 * 
 * @export
 * @interface ParameterCombinationDto
 */
export interface ParameterCombinationDto {
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    combinationSetId?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    hash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    targetSystemId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ParameterCombinationDto
     */
    supportSystemEntityIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ParameterCombinationDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {Array<ISystemSetupCombinationValue>}
     * @memberof ParameterCombinationDto
     */
    targetSystemValues?: Array<ISystemSetupCombinationValue> | null;
    /**
     * 
     * @type {Array<ISystemSetupCombinationValue>}
     * @memberof ParameterCombinationDto
     */
    supportSystemValues?: Array<ISystemSetupCombinationValue> | null;
    /**
     * 
     * @type {ParameterCombinationDtoReferenceMeasurementInfo}
     * @memberof ParameterCombinationDto
     */
    referenceMeasurementInfo?: ParameterCombinationDtoReferenceMeasurementInfo | null;
    /**
     * 
     * @type {EvaluationScopeCategory}
     * @memberof ParameterCombinationDto
     */
    evaluationScopeCategory: EvaluationScopeCategory;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationDto
     */
    $type?: ParameterCombinationDtoTypeEnum;
}


/**
 * @export
 */
export const ParameterCombinationDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsParameterCombinationDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.ParameterCombinationDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ParameterCombinationDtoTypeEnum = typeof ParameterCombinationDtoTypeEnum[keyof typeof ParameterCombinationDtoTypeEnum];


/**
 * Check if a given object implements the ParameterCombinationDto interface.
 */
export function instanceOfParameterCombinationDto(value?: unknown): value is ParameterCombinationDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ParameterCombinationDtoTypeEnum)[0];
}

export function ParameterCombinationDtoFromJSON(json: any): ParameterCombinationDto {
    return ParameterCombinationDtoFromJSONTyped(json, false);
}

export function ParameterCombinationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterCombinationDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'combinationSetId': !exists(json, 'combinationSetId') ? undefined : json['combinationSetId'],
        'hash': !exists(json, 'hash') ? undefined : json['hash'],
        'targetSystemId': !exists(json, 'targetSystemId') ? undefined : json['targetSystemId'],
        'supportSystemEntityIds': !exists(json, 'supportSystemEntityIds') ? undefined : json['supportSystemEntityIds'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'targetSystemValues': !exists(json, 'targetSystemValues') ? undefined : (json['targetSystemValues'] === null ? null : (json['targetSystemValues'] as Array<any>).map(ISystemSetupCombinationValueFromJSON)),
        'supportSystemValues': !exists(json, 'supportSystemValues') ? undefined : (json['supportSystemValues'] === null ? null : (json['supportSystemValues'] as Array<any>).map(ISystemSetupCombinationValueFromJSON)),
        'referenceMeasurementInfo': !exists(json, 'referenceMeasurementInfo') ? undefined : ParameterCombinationDtoReferenceMeasurementInfoFromJSON(json['referenceMeasurementInfo']),
        'evaluationScopeCategory': EvaluationScopeCategoryFromJSON(json['evaluationScopeCategory']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function ParameterCombinationDtoToJSON(value?: ParameterCombinationDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'combinationSetId': value.combinationSetId,
        'hash': value.hash,
        'targetSystemId': value.targetSystemId,
        'supportSystemEntityIds': value.supportSystemEntityIds,
        'isEnabled': value.isEnabled,
        'targetSystemValues': value.targetSystemValues === undefined ? undefined : (value.targetSystemValues === null ? null : (value.targetSystemValues as Array<any>).map(ISystemSetupCombinationValueToJSON)),
        'supportSystemValues': value.supportSystemValues === undefined ? undefined : (value.supportSystemValues === null ? null : (value.supportSystemValues as Array<any>).map(ISystemSetupCombinationValueToJSON)),
        'referenceMeasurementInfo': ParameterCombinationDtoReferenceMeasurementInfoToJSON(value.referenceMeasurementInfo),
        'evaluationScopeCategory': EvaluationScopeCategoryToJSON(value.evaluationScopeCategory),
        '$type': value.$type,
    });
}

